// Call controls + abuse review (setter spec §06.10, §06.10.1–4, §09.12). Schemas in api-call-controls.ts.
// Shared by the WhatsApp and AI-call modules (module: null): an abuse block covers every channel.
import * as C from './api-call-controls.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

export const callControlRoutes = {
  getCallControlConfig: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/call-controls', summary: 'Controles de llamada del proyecto (silencio, duración, aclaraciones)', tag: 'voice',
    minRole: 'advisor', module: null, params: W({ projectId: IdParam }), response: C.CallControlConfigSchema,
  }),
  putCallControlConfig: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/call-controls', summary: 'Guardar los controles de llamada del proyecto', tag: 'voice',
    minRole: 'admin', module: null, params: W({ projectId: IdParam }), body: C.PutCallControlConfigSchema, response: C.CallControlConfigSchema,
  }),
  listAiAbuseCases: route({
    method: 'GET', path: '/workspaces/:workspaceId/ai-abuse-cases', summary: 'Casos de posible abuso marcados por la IA (cola de revisión)', tag: 'voice',
    minRole: 'manager', module: null, params: Ws, query: C.AiAbuseQuerySchema, response: items(C.AiAbuseCaseSchema),
  }),
  getContactAiAttention: route({
    method: 'GET', path: '/workspaces/:workspaceId/contacts/:contactId/ai-attention', summary: 'Estado de atención IA del contacto (en pausa / bloqueado por abuso)', tag: 'voice',
    minRole: 'advisor', module: null, params: W({ contactId: IdParam }), response: C.ContactAiAttentionSchema,
  }),
  decideAiAbuseCase: route({
    method: 'POST', path: '/workspaces/:workspaceId/ai-abuse-cases/:caseId/decision', summary: 'Confirmar (Perdido «Uso indebido» + Bloqueado para IA) o descartar (la IA reanuda)', tag: 'voice',
    minRole: 'manager', module: null, params: W({ caseId: IdParam }), body: C.DecideAiAbuseSchema, response: C.AiAbuseCaseSchema,
  }),
  liftAiBlock: route({
    method: 'POST', path: '/workspaces/:workspaceId/ai-abuse-cases/:caseId/lift', summary: 'Levantar el bloqueo para IA (motivo obligatorio, auditado)', tag: 'voice',
    minRole: 'manager', module: null, params: W({ caseId: IdParam }), body: C.LiftAiBlockSchema, response: C.AiAbuseCaseSchema,
  }),
};
